/**
 * Public marketing lead-capture form submission.
 * Deliberately does not use the compliance `api` axios instance — that
 * instance attaches tenant auth headers and redirects to /login on 401/403,
 * neither of which applies to this unauthenticated public endpoint.
 */

import axios from "axios";

export type LeadRequestType =
  | "demo"
  | "pilot"
  | "pilot_review"
  | "partner"
  | "investor";

export type LeadCaptureRequest = {
  requestType: LeadRequestType;
  fullName: string;
  workEmail: string;
  companyName: string;
  phone?: string;
  message?: string;
  sourcePage?: string;
  // Honeypot — real users never fill this; kept empty and hidden in the form.
  website?: string;
};

export async function submitLead(payload: LeadCaptureRequest): Promise<void> {
  await axios.post(
    "/compliance-api/api/compliance/leads",
    {
      request_type: payload.requestType,
      full_name: payload.fullName,
      work_email: payload.workEmail,
      company_name: payload.companyName,
      phone: payload.phone || undefined,
      message: payload.message || undefined,
      source_page: payload.sourcePage || window.location.pathname,
      website: payload.website || undefined,
    },
    { timeout: 15_000 },
  );
}
